import * as React from "react";
const SvgChewronTop = (props) => /* @__PURE__ */ React.createElement("svg", { width: 48, height: 48, viewBox: "0 0 48 48", fill: "none", stroke: "#000000", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 30L24 18L36 30" }));
export default SvgChewronTop;
